import { RouterOutput } from "@/api/client";

export interface Member {
  id: string;
  documentNumber: string;
  hiringDate?: Date;
  name: string;
  email?: string;
  phone?: string;
  jobRoleId: string;
  departmentId: string;
  permissionRoleIds: string[];
  permissionRoleProfile: PermissionProfiles;
  invitationDate?: string;
  type: "CREATE" | "MIGRATE";
}

export interface CreateMembersForm {
  members: Record<string, Member>;
}

export interface Address {
  zipCode: string;
  street: string;
  number: string | number;
  complement: string;
  district: string;
  state: string;
  city: string;
}

export interface NewCompany {
  id: string;
  address: Address;
  legalName: string;
  name: string;
  registrationNumber: string;
}

export interface CreateCompaniesForm {
  companies: Record<string, NewCompany>;
}

export type PermissionRole = RouterOutput["getPermissionRoles"][number];
export type Department = RouterOutput["getDepartments"][number];
export type JobRole = RouterOutput["getJobRoles"][number];
export type Company = RouterOutput["getCompany"];
export type AddCompanyTermResponse = RouterOutput["addCompanyTerm"];

export enum RoleBuiltInIds {
  ADMIN = "admin",
  BENEFIT_ADMIN = "benefit_admin",
  EXPENSE_ADMIN = "expense_administrator",
}

export enum PermissionProfiles {
  ADMINISTRATOR = "administrator",
  EMPLOYEE = "employee",
  SUPER_ADMINISTRATOR = "super-administrator",
}

export enum SetupWorkflowSteps {
  ADD_MEMBERS,
  INVITE_MEMBERS,
  ADD_COMPANIES,
  SUMMARY,
}

export enum TrackingEvents {
  SETUP_MODULES_ASSESSMENT_CONTINUE_CLICKED = "setup_modules_assessment_continue_clicked",
  SETUP_MODULES_ASSESSMENT_CONTINUE_LATER_CLICKED = "setup_modules_assessment_continue_later_clicked",
  SETUP_MODULES_USAGE_CONTINUE_CLICKED = "setup_modules_usage_continue_clicked",
  SETUP_MODULES_USAGE_CONTINUE_LATER_CLICKED = "setup_modules_usage_continue_later_clicked",
  SETUP_OVERVIEW_CONTINUE_CLICKED = "setup_overview_continue_clicked",
  SETUP_OVERVIEW_CONTINUE_LATER_CLICKED = "setup_overview_continue_later_clicked",
  SETUP_ADD_COMPANIES_CONTINUE_CLICKED = "setup_add_companies_continue_clicked",
  SETUP_ADD_COMPANIES_CONTINUE_LATER_CLICKED = "setup_add_companies_continue_later_clicked",
  SETUP_ADD_COMPANIES_DELETE_CLICKED = "setup_add_companies_delete_clicked",
  SETUP_ADD_COMPANIES_GO_BACK_CLICKED = "setup_add_companies_go_back_clicked",
  SETUP_ADD_INDIVIDUAL_EMPLOYEE_CONTINUE_CLICKED = "setup_add_individual_employee_continue_clicked",
  SETUP_ADD_INDIVIDUAL_EMPLOYEE_DELETE_CLICKED = "setup_add_individual_employee_exclude_clicked",
  SETUP_ADD_INDIVIDUAL_EMPLOYEE_CONTINUE_LATER_CLICKED = "setup_add_individual_employee_continue_later_clicked",
  SETUP_ADD_INDIVIDUAL_EMPLOYEE_GO_BACK_CLICKED = "setup_add_individual_employee_go_back_clicked",
  SETUP_ADD_INDIVIDUAL_EMPLOYEE_PROFILE_CLICKED = "setup_add_individual_employee_profile_clicked",
  SETUP_ADD_INDIVIDUAL_EMPLOYEE_SAVE_CLICKED = "setup_add_individual_employee_save_clicked",
  SETUP_MENU_CLICKED = "setup_menu_clicked",
  SETUP_SEND_INVITE_CONTINUE_CLICKED = "setup_send_invite_continue_clicked",
  SETUP_SEND_INVITE_CONTINUE_LATER_CLICKED = "setup_send_invite_continue_later_clicked",
  SETUP_SEND_INVITE_GO_BACK_CLICKED = "setup_send_invite_go_back_clicked",
  SETUP_STEP_ITEM_CLICKED = "setup_step_item_clicked",
  SETUP_STEP_ITEM_IGNORE_CLICKED = "setup_step_item_ignore_clicked",
  SETUP_STEP_ITEM_RECONSIDER_CLICKED = "setup_step_item_reconsider_clicked",
  SETUP_SUMMARY_COMPLETED_COMPANIES_CLICKED = "setup_summary_completed_companies_clicked",
  SETUP_SUMMARY_COMPLETED_MEMBERS_CLICKED = "setup_summary_completed_people_clicked",
  SETUP_SUMMARY_COMPLETED_JOB_ROLES_CLICKED = "setup_summary_completed_positions_clicked",
  SETUP_SUMMARY_COMPLETED_DEPARTMENTS_CLICKED = "setup_summary_completed_departments_clicked",
}

export enum TrackingPages {
  SETUP_OVERVIEW_WORKFLOW_PAGE = "setup_overview_workflow_page",
  SETUP_MODULES_ASSESSMENT_WORKFLOW_PAGE = "setup_modules_assessment_workflow_page",
  SETUP_MODULES_USAGE_WORKFLOW_PAGE = "setup_modules_usage_workflow_page",
  SETUP_ADD_COMPANIES_WORKFLOW_PAGE = "setup_add_companies_workflow_page",
  SETUP_ADD_INDIVIDUAL_EMPLOYEE_WORKFLOW_PAGE = "setup_add_individual_employee_workflow_page",
  SETUP_SEND_INVITE_WORKFLOW_PAGE = "setup_send_invite_workflow_page",
  SETUP_SUMMARY_WORKFLOW_PAGE = "setup_summary_workflow_page",
}
